import { Box, Typography } from "@mui/material";
import { useState } from "react";
import {
  AutocompleteArrayInput,
  Datagrid,
  Edit,
  FunctionField,
  ListContextProvider,
  Pagination,
  ReferenceArrayInput,
  TabbedForm,
  TextField,
  TextInput,
  useGetList,
  useList,
} from "react-admin";
import { useParams } from "react-router-dom";

const OrganizationField = () => (
  <FunctionField
    label="组织"
    render={(record: any) =>
      record.organizations && record.organizations.length > 0 ? (
        record.organizations.map((org: any) => org.name).join(", ")
      ) : (
        <Typography variant="body2" color="error">
          无组织信息（账号不可用）
        </Typography>
      )
    }
  />
);

const RolesField = () => {
  const roleMapping: { [key: string]: string } = {
    scheduler: "调度员",
    "group-admin": "部门管理员",
    "org-admin": "组织管理员",
    financial:"财务员",
  };

  return (
    <FunctionField
      label="角色"
      render={(record: any) =>
        record.roles && record.roles.length > 0
          ? record.roles
              .filter((role: any) => roleMapping[role.name])
              .map((role: any) => roleMapping[role.name])
              .join(", ")
          : "无角色"
      }
    />
  );
};

export const GroupEdit: React.FC = (props) => {
  const { id } = useParams();
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const { data, total, isLoading } = useGetList(`groups/${id}/members`, {
    pagination: { page: page, perPage: perPage },
    sort: { field: "id", order: "ASC" },
  });

  const listContext = useList({ data, isLoading, perPage, page });

  return (
    <Edit {...props}>
      <TabbedForm>
        <TabbedForm.Tab label="部门管理">
          <TextInput source="name" label="部门名称" />
          <Box mt={2}>
            <Typography variant="h6">部门成员</Typography>
          </Box>
          <ListContextProvider value={{ ...listContext, total: total || 0 }}>
            <Datagrid bulkActionButtons={false}>
              <FunctionField
                label="姓名"
                render={(record: any) =>
                  `${record.lastName} ${record.firstName}`
                }
              />
              <TextField source="username" label="用户名" />
              <TextField source="email" label="邮箱" />
              <FunctionField
                label="邮箱验证"
                render={(record: any) => (record.emailVerified ? "是" : "否")}
              />
              <FunctionField
                label="启用"
                render={(record: any) => (record.enabled ? "是" : "否")}
              />
              <FunctionField
                label="创建时间"
                render={(record: any) =>
                  new Date(record.createdTimestamp).toLocaleString("zh-CN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  })
                }
              />
              <FunctionField
                label="语言"
                render={(record: any) =>
                  record.attributes?.locale?.join(", ") || "无"
                }
              />
              <OrganizationField />
              <RolesField />
            </Datagrid>
            <Pagination page={page} setPage={setPage} setPerPage={setPerPage} />
          </ListContextProvider>
          <ReferenceArrayInput source="members" reference="groups/users">
            <AutocompleteArrayInput
              fullWidth
              optionText={(option) => {
                const name = `${option.lastName ?? ""} ${
                  option.firstName ?? ""
                }`.trim();
                const username = option.username ?? "未知用户名";
                const email = option.email ?? "未知邮箱";
                return `${name} - ${username} - ${email}`;
              }}
              label="添加或移除成员"
              noOptionsText="无选项"
            />
          </ReferenceArrayInput>
        </TabbedForm.Tab>
      </TabbedForm>
    </Edit>
  );
};
